import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Heart, Mail, ExternalLink } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-silver/20 bg-gradient-to-b from-background to-silver-shimmer/10">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-maroon flex items-center justify-center shadow-glow">
                <BookOpen className="w-5 h-5 text-primary-foreground" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-foreground">
                  Taking Your Power Back
                </h3>
                <p className="text-xs text-muted-foreground">E-Course Experience</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              A transformational journey based on Christopher M Duncan's 
              "You're Not Broken" and the 5 Steps of Creation.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-display font-semibold text-foreground">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-sm text-muted-foreground hover:text-maroon transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/chapters" 
                  className="text-sm text-muted-foreground hover:text-maroon transition-colors"
                >
                  All Chapters
                </Link>
              </li>
              <li>
                <Link 
                  to="/progress" 
                  className="text-sm text-muted-foreground hover:text-maroon transition-colors"
                >
                  My Progress
                </Link>
              </li>
              <li>
                <Link 
                  to="/bookmarks" 
                  className="text-sm text-muted-foreground hover:text-maroon transition-colors"
                >
                  Bookmarks
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div className="space-y-4">
            <h4 className="font-display font-semibold text-foreground">About the Course</h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              This course is designed for anyone ready to stop people pleasing, 
              set boundaries, heal trauma, and step into their authentic power.
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Mail className="w-4 h-4 text-maroon" />
              <span>support@takingyourpowerback.com</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-silver/20 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Taking Your Power Back. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-maroon fill-maroon" /> for your transformation
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
